import React from 'react'
import { Table, Modal, Skeleton } from 'antd'
import { TableRowModalEditButton } from '../../../components/AppButton'

class ItemListTable extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleDeleteButtonOnClick = this.handleDeleteButtonOnClick.bind(this)
  }

  handleDeleteButtonOnClick(idnum) {
    const handleTableOnDelete = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Удалить запись',
      content: 'Вы действительно хотите удалить запись?',
      okText: 'Да',
      cancelText: 'Отмена',
      onOk() {
        handleTableOnDelete()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  render() {
    const isEPO = localStorage.getItem('isEPO') === '1'
    
    const columns = [
      {
        title: 'ID',
        dataIndex: 'idnum',
        key: 'idnum',
        sorter: true,
      }, {
        title: 'Название',
        dataIndex: 's_name',
        key: 's_name',
        sorter: true,
      }, {
        title: 'Номер',
        dataIndex: 's_number',
        key: 's_number',
        sorter: true,
      }, {
        title: 'Адрес',
        dataIndex: 's_address',
        key: 's_address',
      }, {
        title: 'Токен',
        dataIndex: 's_token',
        key: 's_token',
      }, {
        title: 'Часовой пояс',
        dataIndex: 'n_time_offset',
        key: 'n_time_offset',
        render: (record, row) => (`UTC +${parseInt(record || 0) + 7}`),
      }, {
        title: 'Идентификатор',
        dataIndex: 's_identity',
        key: 's_identity',
      }, {
        title: 'Редактирование',
        dataIndex: 'action',
        key: 'action',
        render: (row, record) => (
          <span>
            <TableRowModalEditButton
              onClick={() => this.props.setActivePoint(record, true)}
            />
          </span>
        ),
      },
    ]
    return (
      <div>
        <Table
          rowKey={record => `item-row-${record.idnum}`}
          columns={isEPO ? columns.filter(col => col.dataIndex !== 'action') : columns}
          size='middle'
          {...this.props}
        />
      </div>
    )
  }
}

export default ItemListTable



// WEBPACK FOOTER //
// src/containers/SellerForm/PointList/Table.jsx